import { useDeleteStore } from '../../hooks';
import { MenuCategoryDeleteModalView } from '../../components/MenuCategoryDeleteModalView';

export const MenuCategoryDeleteModal = () => {
  const deleteStore = useDeleteStore();

  return <MenuCategoryDeleteModalView {...deleteStore} />;
};
